// =============================================================================
// src/features/crisis/crisis-gauge-hydrate.ts
//
// Patcheia o medidor de risco (gauge) da Crise com o crisis_score VIVO do tópico
// ativo (v_crisis_metrics_24h, migration 041): a legenda "X/100 · tendência" e o
// preenchimento do arco. No-op sem crise ativa (mantém o mock 62/100). Módulo
// separado da geometria (que não pode importar o store — ciclo via EVO_SERIES).
// =============================================================================

import { qs } from '../../app/dom';
import { getCrisisMetrics } from './crisis-live-store';

/** Tendência do gauge a partir da aceleração da série (rising/falling/stable). */
const ACCEL_CAP: Record<string, string> = {
  rising: 'tende a subir',
  falling: 'tende a cair',
  stable: 'estável',
};

function accelCap(acceleration: string | undefined): string {
  return ACCEL_CAP[acceleration ?? ''] ?? 'estável';
}

/** Atualiza legenda + arco do gauge com o gauge vivo (0-100). No-op sem crise ativa. */
export function hydrateCrisisGauge(takeover: HTMLElement): void {
  const metrics = getCrisisMetrics();
  if (metrics?.gauge == null) return;
  const gauge = Math.round(metrics.gauge);
  const cap = qs<HTMLElement>('.crz-gauge-cap', takeover);
  /* v8 ignore next -- markup sempre tem .crz-gauge-cap; guarda defensiva CLAUDE.md rule 11 */
  if (cap) cap.textContent = `${gauge}/100 · ${accelCap(metrics.acceleration)}`;
  fillGaugeArcLive(takeover, gauge / 100);
}

/** Preenche o arco até `fraction` (espelha fillGaugeArc da geometria, com fração viva). */
function fillGaugeArcLive(takeover: HTMLElement, fraction: number): void {
  const arc = qs<SVGPathElement>('#crzGaugeArc', takeover);
  /* v8 ignore next -- markup sempre tem #crzGaugeArc; guarda defensiva CLAUDE.md rule 11 */
  if (!arc) return;
  const total = arc.getTotalLength();
  arc.style.strokeDasharray = String(total);
  arc.style.strokeDashoffset = String(total * (1 - fraction));
}
